/**
 * Makes use of the observer API to check when an element
 * enters the viewport and applys a class
 * @param {element} element Element to check
 * @param {number} threshold Determines how much of the element has to be visibile
 * @param {func} callback Callback function
 * @returns {void}
 */
export default (element, threshold, callback) => {
  let observer = null;

  const intersectionObserverOptions = {
    threshold
  };

  observer = new IntersectionObserver(callback, intersectionObserverOptions);
  observer.observe(element);
};
